export const facebookImage = require("../assets/facebook-circled.png");
export const googleImage = require("../assets/GoogleLogo.png");

export const imgLogo = require('../assets/logo_img.png');
export const imgLogoText = require('../assets/logo_text.png');
export const imgLogoRound = require('../assets/logo.png');